export default function menuList(styles) {
  return {
    ...styles,
    padding: 0,
    maxHeight: 164,
    borderBottomLeftRadius: "inherit",
    borderBottomRightRadius: "inherit",
    overflow: "auto",
  };
}
